import React, { useState } from 'react';
import Modal from 'react-modal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faUser, faBuilding } from '@fortawesome/free-solid-svg-icons';


import { faCheck } from '@fortawesome/free-solid-svg-icons';

const customModalStyles = {
  content: {
    width: '80%', 
    height: '85%',
    maxWidth: '600px',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    //justifyContent: 'center', // Center vertically
    alignItems: 'center', // Center horizontally
    borderRadius: '1%',
  },
};

const greenStyle = {
  backgroundColor: 'green',
  width: '64px',
  height: '64px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  padding: '16px',
};

const redStyle = {
  backgroundColor: 'red',
  width: '64px',
  height: '64px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  padding: '16px',
};

const SimpleModal = ({ isOpen, onRequestClose, registrationStatus, registrationError, message }) => {

  const [isModalOpen, setIsModalOpen] = useState(false);

  
  

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel=""
      style={customModalStyles}
    >
      <div className="flex flex-col justify-between w-full text-center pb-6 items-center">
        <div className="pt-8 pb-8">
          {registrationStatus === 'Upload Certificate Successful' ? (
            <FontAwesomeIcon
              icon={faCheck}
              color="white"
              className="ml-4 mr-4"
              style={{ ...greenStyle }}
              
            />
          ) : (
            <FontAwesomeIcon
              icon={faTimes}
              color="white"
              className="ml-4 mr-4"
              style={{ ...redStyle }}
            />
          )}
        </div>
        <h2
          style={{ fontSize: '2rem', marginTop: '0' }}
          className={`text-2xl sm:text-2xl md:text-4xl lg:text-4xl xl:text-4xl ${
            registrationStatus === 'Upload Certificate Successful'
              ? 'text-green-500'
              : 'text-red-500'
          } py-2`}
        >
          {registrationStatus === 'Upload Certificate Successful'
            ? message + ' Upload Successful'
            : message + ' Upload Failed'}
        </h2>
        <div className="pt-4">
          {registrationStatus === 'Upload Certificate Successful'
            ? ''
            : ''}
        </div>
      </div>


      <div className='text-center mb-4  mx-8' dangerouslySetInnerHTML={{ __html: registrationError }}></div>

      <button className="rounded-button-blue pt-4 shadow-lg" onClick={onRequestClose}>
        Done
      </button>
    </Modal>
  );
};

export default SimpleModal;
